<p-toast></p-toast>

<div class="checkout-container w-full min-h-screen p-3 md:p-5 mt-8">

  <div class="mb-5">
    <h1 class="font-prata text-3xl m-0">Finalizar Compra</h1>
    <p class="text-600 mt-1">Completa la información de envío y pago.</p>
  </div>

  <div class="grid">

    <div class="col-12 lg:col-8">

      <div class="card p-4 border-round-xl bg-white shadow-1 mb-4">
        <h3 class="section-title mb-4">
          <span class="step-badge">1</span> Datos Personales
        </h3>

        <div class="formgrid grid p-fluid">
          <div class="field col-12 md:col-6">
            <label class="font-bold text-sm mb-1 block">Nombre Completo</label>
            <input pInputText [(ngModel)]="orderData.clientName" placeholder="Tu nombre" />
          </div>

          <div class="field col-12 md:col-6">
            <label class="font-bold text-sm mb-1 block">DNI / CE (Obligatorio)</label>
            <input pInputText [(ngModel)]="orderData.dni" placeholder="8 dígitos" maxlength="12" />
          </div>

          <div class="field col-12 md:col-6">
            <label class="font-bold text-sm mb-1 block">Celular</label>
            <input pInputText [(ngModel)]="orderData.clientPhone" placeholder="999..." />
          </div>
          <div class="field col-12 md:col-6">
            <label class="font-bold text-sm mb-1 block">Correo Electrónico</label>
            <input pInputText [(ngModel)]="orderData.email" placeholder="correo@ejemplo.com" />
          </div>
        </div>
      </div>

      <div class="card p-4 border-round-xl bg-white shadow-1 mb-4">
        <h3 class="section-title mb-4">
          <span class="step-badge">2</span> Envío a Domicilio
        </h3>

        <div class="field p-fluid mb-3">
          <label class="font-bold text-sm mb-1 block">Tipo de Envío</label>
          <p-select [options]="tiposEnvio"
                    [(ngModel)]="tipoEnvioId"
                    optionLabel="nombreTipoEnvio"
                    optionValue="id"
                    placeholder="Seleccionar..."
                    (onChange)="onTipoEnvioChange()"
                    styleClass="w-full">
            <ng-template let-item pTemplate="item">
              <div class="flex justify-content-between w-full gap-3">
                <span>{{item.nombreTipoEnvio}}</span>
                <span class="font-bold text-green-600">+ {{ (item.precio || 0) | currency:'PEN':'symbol' }}</span>
              </div>
            </ng-template>
          </p-select>
        </div>

        <div *ngIf="savedAddress" class="mb-3 flex flex-column gap-2">
          <div class="delivery-option"
               [class.selected]="useSavedAddress"
               (click)="onAddressModeChange(true)">
            <p-radioButton name="addrMode" [value]="true" [(ngModel)]="useSavedAddress"
                           (ngModelChange)="onAddressModeChange(true)" inputId="addr1"></p-radioButton>
            <label for="addr1" class="ml-2 cursor-pointer w-full">
              <span class="font-bold block">Usar mi dirección guardada</span>
              <span class="text-sm text-600">{{ savedAddress.label }}</span>
            </label>
          </div>
          <div class="delivery-option"
               [class.selected]="!useSavedAddress"
               (click)="onAddressModeChange(false)">
            <p-radioButton name="addrMode" [value]="false" [(ngModel)]="useSavedAddress"
                           (ngModelChange)="onAddressModeChange(false)" inputId="addr2"></p-radioButton>
            <label for="addr2" class="ml-2 font-bold cursor-pointer w-full">Usar otra dirección</label>
          </div>
        </div>

        <div *ngIf="useSavedAddress && savedAddress" class="info-box mb-3 bg-green-50 p-3 border-round border-1 border-green-200">
          <div class="text-sm text-900"><strong>Envío a:</strong> {{ savedAddress.label }}</div>
          <div class="text-sm text-600 mt-1">Costo de envío: S/ {{ deliveryCost | number:'1.2-2' }}</div>
        </div>

        <div *ngIf="!useSavedAddress || !savedAddress" class="formgrid grid p-fluid">
          <div class="field col-12 md:col-6">
            <label class="font-bold text-sm mb-1 block">País</label>
            <p-select [options]="paises" [(ngModel)]="paisId" (onChange)="onPaisChange()"
                      optionLabel="nombre" optionValue="id" placeholder="País" styleClass="w-full"></p-select>
          </div>
          <div class="field col-12 md:col-6">
            <label class="font-bold text-sm mb-1 block">Departamento</label>
            <p-select [options]="departamentos" [(ngModel)]="departamentoId" (onChange)="onDepartamentoChange()"
                      optionLabel="nombre" optionValue="id" placeholder="Departamento" styleClass="w-full"></p-select>
          </div>
          <div class="field col-12 md:col-6">
            <label class="font-bold text-sm mb-1 block">Provincia</label>
            <p-select [options]="provincias" [(ngModel)]="provinciaId" (onChange)="onProvinciaChange()"
                      optionLabel="nombre" optionValue="id" placeholder="Provincia" styleClass="w-full"></p-select>
          </div>
          <div class="field col-12 md:col-6">
            <label class="font-bold text-sm mb-1 block">Distrito</label>
            <p-select [options]="distritosUbigeo" [(ngModel)]="distritoId" (onChange)="onDistritoUbigeoChange()"
                      optionLabel="nombre" optionValue="id" placeholder="Distrito" styleClass="w-full"></p-select>
          </div>
          <div class="field col-12">
            <label class="font-bold text-sm mb-1 block">Dirección Exacta</label>
            <input pInputText [(ngModel)]="orderData.deliveryAddress" placeholder="Av. Principal 123..." />
          </div>
          <div class="field col-12">
            <label class="font-bold text-sm mb-1 block">Referencia</label>
            <input pInputText [(ngModel)]="orderData.reference" placeholder="Frente al parque..." />
          </div>
        </div>

        <div *ngIf="useSavedAddress && savedAddress" class="field p-fluid mt-2">
          <label class="font-bold text-sm mb-1 block">Referencia (opcional)</label>
          <input pInputText [(ngModel)]="orderData.reference" placeholder="Frente al parque..." />
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-4">
      <div class="card p-4 border-round-xl bg-white shadow-1 sticky" style="top: 20px;">
        <h3 class="font-prata text-xl mb-4">Resumen del Pedido</h3>

        <ul class="list-none p-0 m-0 mb-4 max-h-25rem overflow-y-auto custom-scroll">
          <li *ngFor="let item of cartService.cartItems()" class="flex align-items-center gap-3 mb-3 pb-3 border-bottom-1 border-gray-100">
            <img [src]="item.productImage" class="w-4rem h-4rem border-round object-cover bg-gray-50" />
            <div class="flex-1">
              <div class="font-bold text-900 text-sm">{{item.productName}}</div>
              <div class="text-xs text-500 mt-1">
                <span class="bg-gray-100 p-1 border-round mr-1">{{item.quantity}}uni</span>
                <span *ngIf="item.selectedSize" class="bg-gray-100 p-1 border-round">{{item.selectedSize}}</span>
                <span *ngIf="item.selectedColor" class="ml-1">| {{item.selectedColor}}</span>
              </div>
            </div>
            <div class="font-bold text-900">
              {{ item.subTotal | currency:'PEN':'symbol' }}
            </div>
          </li>
        </ul>

        <div class="flex justify-content-between mb-2 text-sm">
          <span class="text-600">Subtotal</span>
          <span class="font-bold text-900">{{ cartService.subtotal() | currency:'PEN':'symbol' }}</span>
        </div>
        <div class="flex justify-content-between mb-2 text-sm">
          <span class="text-600">Envío</span>
          <span class="font-bold text-900">{{ deliveryCost | currency:'PEN':'symbol' }}</span>
        </div>

        <div class="divider border-top-1 border-gray-300 my-3"></div>

        <div class="flex justify-content-between align-items-center mb-4">
          <span class="text-xl font-bold text-900 font-prata">Total</span>
          <span class="text-2xl font-bold text-900 font-prata">
              {{ (cartService.subtotal() + deliveryCost) | currency:'PEN':'symbol' }}
          </span>
        </div>

        <div class="mb-3 p-3 border-round-lg bg-blue-50 border-1 border-blue-100">
          <div class="flex align-items-start gap-2">
            <i class="pi pi-shield text-blue-600 mt-1"></i>
            <div class="text-sm text-blue-900 line-height-3">
              Pagaras de forma segura con <strong>Mercado Pago</strong>. Seras redirigido para completar el pago.
            </div>
          </div>
        </div>

        <button pButton label="PAGAR" icon="pi pi-credit-card"
                class="checkout-btn w-full border-round-lg font-bold text-lg"
                (click)="payWithMercadoPago()" [loading]="isLoading" [disabled]="isLoading">
        </button>
      </div>
    </div>

  </div>
</div>
